'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.503 2.492c-.398 0-.763.22-.95.57l-.365.684H2.9a.9.9 0 1 0 0 1.8h14.277a.9.9 0 1 0 0-1.8h-4.534l-.215-.562a1.08 1.08 0 0 0-1.005-.692z", fill: props.fillColor, fillOpacity: 0.92 }),
    React__namespace.createElement("path", { d: "m4.378 7.59.91 7.787a2.153 2.153 0 0 0 2.138 1.903h5.217c1.07 0 1.978-.786 2.13-1.845l1.135-7.845m-7.37 1.616v4.306m3.23-4.306v4.306", stroke: props.strokeColor, strokeOpacity: 0.92, strokeWidth: 1.8, strokeLinecap: "round" })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
